import React from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import LoginView from "./admin/LoginView";
import Dashboard from "./admin/Dashboard";

const Admin = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-[#00A651]" />
      </div>
    );
  }

  return user ? <Dashboard /> : <LoginView />;
};

export default Admin;
